import { CategoryType } from '@diritto/common/content/constants';

export enum ProfileSettingType {
  None = 'None',
  FavoriteCategory = 'FavoriteCategory',
}

export const ProfileSettingTypeString = {
  [ProfileSettingType.None]: '-',
  [ProfileSettingType.FavoriteCategory]: '선호장르',
};

export const ProfileSettingTypeOptions = Object.values(ProfileSettingType).map(it => ({
  label: ProfileSettingTypeString[it],
  id: it,
  value: it,
}));

export type ProfileSettingTypeNone = {
  type: ProfileSettingType.None;
};

export type ProfileSettingTypeFavoriteCategoryPayload = {
  type: ProfileSettingType.FavoriteCategory;
  payload: {
    /** @deprecated TODO: [2025-09-22] Deprecated categoryTypes, Target App Version 2.17.4.1 ~ */
    categoryTypes?: CategoryType[];
    categoryIds?: number[];
  };
};

export interface ProfileSettingTypeExtraInfo {
  [ProfileSettingType.None]: ProfileSettingTypeNone;
  [ProfileSettingType.FavoriteCategory]: ProfileSettingTypeFavoriteCategoryPayload;
}
